import { _banner } from "../constants/api";

export const fetchBanners = async () => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_banner}`, {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to fetch banners: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in fetchBanners API ==> ', error);
    throw error;
  }
};

export const createBanner = async (image) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    

    const response = await fetch(`${_banner}/create`, {
      method: "POST",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: image,
    });

    if (!response.ok) {
      throw new Error(`Failed to create banner: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in createBanner API ==> ', error);
    throw error;
  }
};

export const updateBanner = async (id, image) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const formData = new FormData();
    formData.append("image", image);

    const response = await fetch(`${_banner}/${id}`, {
      method: "PUT",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Failed to update banner: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in updateBanner API ==> ', error);
    throw error;
  }
};

export const deleteBanner = async (id) => {
  try {
    const userData = JSON.parse(localStorage.getItem('user')); 
    const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }

    const response = await fetch(`${_banner}/${id}`, {
      method: "DELETE",
      headers: {
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    if (!response.ok) {
      throw new Error(`Failed to delete banner: ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.log('Error in deleteBanner API ==> ', error);
    throw error;
  }
};
